import React, { useState } from 'react'
import { API, Input } from '@enkla-gui'
import { notify } from '@/_helpers'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

export default function Reset() {
	const { register, handleSubmit } = useForm()
	const [error, setError] = useState(null)
	let { token } = useParams()

	var onSubmit = data => {
		data.token = token
		API.post('api/auth/reset', data)
			.then(res => {
				notify.toast('Lösenordet har återställts')
				window.location.hash = '/'
			})
			.catch(([error, res]) => {
				setError({
					message: res.message,
					data: res.data
				})
			})
	}
	return (
		<div className='full-height login-page'>
			<div className='login-card'>
				<div className='login-card-inner'>
					<div className='login-info'>
						<div className='login-info-content'>
							<div className='login-accent-dot' />
							<span className='login-welcome'>Återställ lösenord</span>
							<h2>Välj ett nytt</h2>
							<p className='login-info-subtitle'>Ange din e-post och ditt nya lösenord</p>
							<div className='login-accent-line' />
						</div>
					</div>
					<div className='login-form-section'>
						<form onSubmit={handleSubmit(onSubmit)}>
							{error?.message && <div className='alert alert-danger'>{error.message}</div>}
							<Input
								controls={{ register }}
								name='email'
								options={{ required: true }}
								label='E-post'
								type='text'
								placeholder='din@epost.se'
								error={error}
							/>
							<Input
								controls={{ register }}
								name='password'
								options={{ required: true }}
								label='Nytt lösenord'
								type='password'
								error={error}
							/>
							<Input
								controls={{ register }}
								name='password_confirmation'
								options={{ required: true }}
								label='Verifiera lösenord'
								type='password'
								error={error}
							/>
							<button type='submit' className='btn login-btn'>
								Återställ lösenord
							</button>
						</form>
						<div className='login-card-links'>
							<p className='login-register-link'>
								<a href='#/login'>Tillbaka till inloggning</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
